var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "primary" },
                    on: { click: _vm.voltar }
                  },
                  [
                    _c("i", { staticClass: "fas fa-arrow-alt-circle-left" }),
                    _vm._v(" Voltar")
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-2" }, [
          _c(
            "label",
            { staticClass: "text-primary label-status", attrs: { for: "" } },
            [_vm._v("Status")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.status,
                  expression: "status"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "", id: "" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.status = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.changeData
                ]
              }
            },
            [
              _c("option", { attrs: { value: "ABERTO" } }, [_vm._v("ABERTOS")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "ATRASADOS" } }, [
                _vm._v("ATRASADOS")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "BAIXADO" } }, [
                _vm._v("BAIXADOS")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "CANCELADO" } }, [
                _vm._v("CANCELADOS")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "TODOS" } }, [_vm._v("TODOS")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("N. Fatura")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.fatura,
                  expression: "fatura"
                }
              ],
              staticClass: "form-control",
              domProps: { value: _vm.fatura },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.fatura = $event.target.value
                  },
                  _vm.changeData
                ]
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c(
            "label",
            { staticClass: "text-primary label-status", attrs: { for: "" } },
            [_vm._v("Banco")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.banco,
                  expression: "banco"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "", id: "" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.banco = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.changeData
                ]
              }
            },
            [
              _c("option", { attrs: { value: "0" } }, [_vm._v("TODOS")]),
              _vm._v(" "),
              _vm._l(_vm.bancos, function(bc) {
                return _c(
                  "option",
                  { key: bc.id, domProps: { value: bc.id } },
                  [
                    _vm._v(
                      "\r\n                    " +
                        _vm._s(bc.nome) +
                        "\r\n                "
                    )
                  ]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("De")]),
              _vm._v(" "),
              _c("date-picker", {
                attrs: {
                  disabled: _vm.status === "ABERTO",
                  config: _vm.datePickerConfig
                },
                on: { "dp-change": _vm.onStartChange },
                model: {
                  value: _vm.fromDate,
                  callback: function($$v) {
                    _vm.fromDate = $$v
                  },
                  expression: "fromDate"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2" }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Até")]),
              _vm._v(" "),
              _c("date-picker", {
                attrs: {
                  disabled: _vm.status === "ABERTO",
                  config: _vm.datePickerConfig
                },
                on: { "dp-change": _vm.onEndChange },
                model: {
                  value: _vm.toDate,
                  callback: function($$v) {
                    _vm.toDate = $$v
                  },
                  expression: "toDate"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.isDist === 0
          ? _c("div", { staticClass: "col-md-2 text-center" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [
                  _vm._v("Cod. Distribuidor")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.distribuidor,
                      expression: "distribuidor"
                    }
                  ],
                  staticClass: "form-control",
                  domProps: { value: _vm.distribuidor },
                  on: {
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.distribuidor = $event.target.value
                      },
                      _vm.changeData
                    ]
                  }
                })
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _vm.isCD !== 10
                ? _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _vm.isDist === 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mb-2",
                              attrs: { variant: "primary", size: "sm" },
                              on: { click: _vm.showDelete }
                            },
                            [
                              _c("i", { staticClass: "fas fa-check-circle" }),
                              _vm._v(" Selecionar")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDist === 0 && _vm.markDelete.length > 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mb-2",
                              attrs: { variant: "danger", size: "sm" },
                              on: { click: _vm.confirmDelete }
                            },
                            [
                              _c("i", { staticClass: "fas fa-times-circle" }),
                              _vm._v(" Excluir")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("b-table", {
                        attrs: {
                          items: _vm.boletos,
                          fields: _vm.showHeader,
                          busy: _vm.loadingBoletos,
                          "current-page": _vm.pageBoleto,
                          "per-page": _vm.perPage,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                          "sort-direction": _vm.sortDirection,
                          stacked: "md",
                          "show-empty": "",
                          small: ""
                        },
                        on: {
                          "update:sortBy": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function($event) {
                            _vm.sortDesc = $event
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-busy",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-danger my-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle"
                                      }),
                                      _vm._v(" "),
                                      _c("strong", [_vm._v("Carregando ..")])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "empty",
                              fn: function() {
                                return [
                                  _c("h4", [_vm._v("Nenhum dado encontrado!")])
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "cell(numero_documento)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        disabled:
                                          row.item.status === "CANCELADO",
                                        href: "/boleto/generate/" + row.item.id,
                                        target: "_blank"
                                      }
                                    },
                                    [_vm._v(_vm._s(row.value))]
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(deletar)",
                              fn: function(row) {
                                return [
                                  row.item.status === "ABERTO" &&
                                  _vm.isDist === 0
                                    ? _c("b-form-checkbox", {
                                        on: {
                                          change: function($event) {
                                            return _vm.marcarDeletado(
                                              row.item.id
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4282411566
                        )
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.totalBoletos,
                          "per-page": _vm.perPage,
                          align: "fill",
                          size: "sm"
                        },
                        model: {
                          value: _vm.pageBoleto,
                          callback: function($$v) {
                            _vm.pageBoleto = $$v
                          },
                          expression: "pageBoleto"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isCD === 10
                ? _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "table",
                          {
                            staticClass:
                              "table table-bordered table-hover table-striped"
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "tbody",
                              _vm._l(_vm.showBoletosAg, function(boleto) {
                                return _c("tr", { key: boleto.id }, [
                                  _c("td", [
                                    boleto.lote
                                      ? _c(
                                          "a",
                                          {
                                            attrs: { href: "#" },
                                            on: {
                                              click: function($event) {
                                                return _vm.openModal(boleto)
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(boleto.lote))]
                                        )
                                      : _c("span", [_vm._v("#")])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(boleto.status))]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\r\n                                                " +
                                        _vm._s(
                                          boleto.data_documento
                                            ? _vm.formatDate(
                                                boleto.data_documento
                                              )
                                            : ""
                                        ) +
                                        "\r\n                                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\r\n                                                " +
                                        _vm._s(
                                          boleto.vencimento
                                            ? _vm.formatDate(boleto.vencimento)
                                            : ""
                                        ) +
                                        "\r\n                                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\r\n                                                " +
                                        _vm._s(
                                          boleto.data_documento
                                            ? _vm.faddDate(
                                                boleto.vencimento,
                                                12
                                              )
                                            : ""
                                        ) +
                                        "\r\n                                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  boleto.lote == "999999"
                                    ? _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "/boleto/generate/" + boleto.id,
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\r\n                                                    Imprimir\r\n                                                "
                                            )
                                          ]
                                        )
                                      ])
                                    : _c("td", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: boleto.lote
                                                ? "/boleto/lote/" + boleto.lote
                                                : "/boleto/generate/" +
                                                  boleto.id,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("Imprimir todos")]
                                        )
                                      ])
                                ])
                              }),
                              0
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            size: "xl",
            scrollable: "",
            title: "Boletos do Lote " + _vm.lote
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right",
                      attrs: { variant: "primary", size: "sm" },
                      on: { click: _vm.fecharModalBoleto }
                    },
                    [_vm._v("Fechar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openedModalBoleto,
            callback: function($$v) {
              _vm.openedModalBoleto = $$v
            },
            expression: "openedModalBoleto"
          }
        },
        [
          _c(
            "b-card",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { attrs: { for: "status" } }, [
                        _vm._v("Status")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-select", {
                            attrs: { id: "status", options: _vm.options },
                            model: {
                              value: _vm.filter,
                              callback: function($$v) {
                                _vm.filter = $$v
                              },
                              expression: "filter"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-4" },
                    [
                      _c("label", { attrs: { for: "rev" } }, [
                        _vm._v("Distribuidor / Revendedora")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-input-group",
                        { attrs: { size: "sm" } },
                        [
                          _c("b-form-input", {
                            attrs: { id: "rev" },
                            model: {
                              value: _vm.filterRev,
                              callback: function($$v) {
                                _vm.filterRev = $$v
                              },
                              expression: "filterRev"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", { attrs: { for: "dataV" } }, [
                        _vm._v("Data de Vencimento")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-input-group",
                        { staticClass: "mb-3" },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              id: "dataV",
                              placeholder: "Nenhuma data selecionada",
                              dropleft: "",
                              "calendar-width": "200",
                              dark: "",
                              "label-help": "",
                              "reset-button": "",
                              "label-reset-button": "Limpar",
                              size: "sm",
                              "date-format-options": {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric"
                              },
                              locale: "pt-BR"
                            },
                            model: {
                              value: _vm.filterDateVencimento,
                              callback: function($$v) {
                                _vm.filterDateVencimento = $$v
                              },
                              expression: "filterDateVencimento"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", { attrs: { for: "dataB" } }, [
                        _vm._v("Data de Baixa")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-input-group",
                        { staticClass: "mb-3" },
                        [
                          _c("b-form-datepicker", {
                            attrs: {
                              id: "dataB",
                              placeholder: "Nenhuma data selecionada",
                              dropleft: "",
                              "calendar-width": "200",
                              dark: "",
                              "label-help": "",
                              "reset-button": "",
                              "label-reset-button": "Limpar",
                              size: "sm",
                              "date-format-options": {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric"
                              },
                              locale: "pt-BR"
                            },
                            model: {
                              value: _vm.filterDate,
                              callback: function($$v) {
                                _vm.filterDate = $$v
                              },
                              expression: "filterDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-table", {
                staticClass: "mt-2",
                attrs: {
                  items: _vm.showBoletosModal,
                  fields: _vm.fields,
                  striped: "",
                  hover: "",
                  stacked: "md",
                  "show-empty": "",
                  "current-page": _vm.currentPage,
                  "per-page": _vm.perPage,
                  filter: _vm.filter,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "sort-direction": _vm.sortDirection
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function($event) {
                    _vm.sortDesc = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(id)",
                    fn: function(row) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "/boleto/generate/" + row.item.id,
                              target: "_blank"
                            }
                          },
                          [_c("i", { staticClass: "fas fa-file-pdf" })]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.totalRows > 9
                ? _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "fill",
                      size: "sm"
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Lote")]),
        _vm._v(" "),
        _c("th", [_vm._v("Situação Lote")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data Emissão")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data Vencimento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Data Limite Devolução")]),
        _vm._v(" "),
        _c("th", [_vm._v("Imprimir")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-617649b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617649b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/boleto/antigos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-617649b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/boleto/antigos.vue
// module chunks = 2